

















    import {Vue, Component, Watch} from "vue-property-decorator";
    import { Notice } from "../toast/type/Notice";
    import ToastNotice from "@service/components/toast/ToastNotice.vue";
    import { noticeActions } from "@service/store/notice/actions";
    import { NoticeProxy } from "./helpers/NoticeProxy";
    import { NoticeFabric } from "./helpers/NoticeFabric";

@Component({
    components: { ToastNotice }
})
export default class NoticeHub extends Vue {

    closeDelay = 5000;
    localQueue: Record<number, Notice> = Vue.observable({});
    timers: Record<string,  NodeJS.Timeout> = {};

    mounted() {

        this.$store.dispatch(noticeActions.setProxy,
            new NoticeProxy(
                this.$store.dispatch,
                new NoticeFabric()
            )
        );
    }

    close(key: number | string, notice?: Notice) {
        if(notice?.groupId) {
            this.clearTimer(key);
            this.$store.dispatch(noticeActions.removeGroup, notice.groupId)
        }

        Vue.delete(this.localQueue, key);
    }

    @Watch("queue")
    watchQueue(notices: Notice[]) {

        if(notices.length > 0) {

            notices.forEach((notice) => {

                const key = notice.groupId ? notice.groupId : 'a' + Math.round(Math.random() * 10000).toString();

                //reset counter if same group in queue
                if(notice.groupId && Object.prototype.hasOwnProperty.call(this.localQueue, key)) {
                    this.$emit('reset-counter', key)
                    this.clearTimer(key);
                }

                Vue.set(this.localQueue, key, notice);

                const timer = setTimeout(() => {
                    this.close(key, notice);
                    this.clearTimer(key)
                }, this.closeDelay)

                this.timers[key] = timer;
            })

            this.$store.dispatch(noticeActions.clearQueue)

            //принимаем новое значение массива из объектов сырых данных
            //вытаскиваем первый элемент
            //кладем в локальный список
            //удаляем когда необходимо
        }
    }

    clearTimer(key: number | string) {
        clearTimeout(this.timers[key])
        delete this.timers[key]
    }

    get queue() {
      return this.$store.state.notice.queue
    }

    getGroupQuantity(groupId: string) {
        return groupId ? Object.keys(this.$store.state.notice.groups[groupId] ?? {}).length : 0;
    }

}
